import React, {useCallback, useEffect} from 'react';
import styled from 'styled-components';
import ReactModalContent from '../Shared/Modal/ReactModalContent';
import ReactModalFooter from '../Shared/Modal/ReactModalFooter';
import {BeaconModal} from "../Shared/Modal/BeaconModal";
import ReactModalHeader from "../Shared/Modal/ReactModalHeader";
import {useDispatch} from "react-redux";
import {
    getAddConsentRequestData,
    getPutServiceCallForDailyPrices,
    getPutServiceCallForMonthlyPerformance,
    getSaveDailyPricesInvestmentoptions,
    getSaveDailyPricesPreferences,
    getSaveMonthlyPerformanceInvestmentOptions,
    getSaveMonthlyPerformancePreferences,
    getServiceProductDailyPricesRequestData,
    getServiceProductMonthlyPerformanceRequestData,
    getServiceStatusDailyPricesRequestData,
    getServiceStatusMonthlyPerformanceRequestData
} from "../../redux/profile/selectors";
import {UseAppSelector} from "../../redux/configure-store";
import {ANALYTICS_IDS} from "../../utils/analyticsTrackingConstants";
import { savePreferencesAndSubscriptions } from "../../redux/profile/slice";

const StyledText = styled.div`
  margin-top: 16px;
  font-family: 'Nimbus Sans Novus';
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: 0.02px;
  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 1.33;
  }
  @media (max-width: 540px) {
    font-size: 16px;
    line-height: 1.5;
  }
`;

const StyledList = styled.div`
  margin-left: 40px;
  margin-top:12px;
  li  {
    display: list-item;
    list-style-type: disc;
  }
`;

export const EDeliveryAgreementModal = ({modalName,handleCloseModal,dispatchOverlayLoad}) => {
    const dispatch = useDispatch();

    useEffect(() => {
        const overlay = "E-Delivery Agreement Modal";
        dispatchOverlayLoad(overlay);
    }, []);

    const addConsentsRequestData = UseAppSelector(getAddConsentRequestData);
    const serviceStatusDailyPricesRequestData = UseAppSelector(getServiceStatusDailyPricesRequestData);
    const serviceStatusMonthlyPerformanceRequestData = UseAppSelector(getServiceStatusMonthlyPerformanceRequestData);
    const serviceProductDailyPricesRequestData = UseAppSelector(getServiceProductDailyPricesRequestData);
    const serviceProductMonthlyPerformanceRequestData = UseAppSelector(getServiceProductMonthlyPerformanceRequestData);
    const saveDailyPricesPreferences = UseAppSelector(getSaveDailyPricesPreferences);
    const saveMonthlyPerformancePreferences = UseAppSelector(getSaveMonthlyPerformancePreferences);
    const putServiceCallForDailyPrices = UseAppSelector(getPutServiceCallForDailyPrices);
    const putServiceCallForMonthlyPerformance = UseAppSelector(getPutServiceCallForMonthlyPerformance);
    const saveDailyPricesInvestmentOptions = UseAppSelector(getSaveDailyPricesInvestmentoptions);
    const saveMonthlyPerformanceInvestmentOptions = UseAppSelector(getSaveMonthlyPerformanceInvestmentOptions);

    const servicesAndRequest:any ={};

    const savePreferences = useCallback(() => {
        servicesAndRequest.addConsents = addConsentsRequestData;
        if(saveDailyPricesPreferences){
            if(putServiceCallForDailyPrices)
            {
                servicesAndRequest.updateServiceStatusDaily = serviceStatusDailyPricesRequestData;
                if(saveDailyPricesInvestmentOptions){
                    servicesAndRequest.updateServiceProductsDaily = serviceProductDailyPricesRequestData;
                }
            }
            else
                servicesAndRequest.deleteServiceStatusDaily = serviceStatusDailyPricesRequestData;
        }

        if(saveMonthlyPerformancePreferences){
            if(putServiceCallForMonthlyPerformance){
                servicesAndRequest.updateServiceStatusMonthly = serviceStatusMonthlyPerformanceRequestData;
                if(saveMonthlyPerformanceInvestmentOptions){
                    servicesAndRequest.updateServiceProductsMonthly = serviceProductMonthlyPerformanceRequestData;
                }
            }
            else
                servicesAndRequest.deleteServiceStatusMonthly = serviceStatusMonthlyPerformanceRequestData;
        }
        dispatchPreferencesAndSubscriptions(servicesAndRequest)
        handleCloseModal();
    },[dispatch]);

    const dispatchPreferencesAndSubscriptions = useCallback((serviceAndRequest) => {
        dispatch(savePreferencesAndSubscriptions({serviceAndRequest}))
    }, [dispatch]);


    const getFooter = () => {
        return <ReactModalFooter
            primaryButtonText = {"Save Preferences"}
            handleOnClick = {savePreferences}
            primaryButtonId = {ANALYTICS_IDS.ModalSavePreferencesBtn}
        />
    };

    return (
        <React.Fragment>
            <BeaconModal id={modalName}
                         footer={getFooter()}>
                <ReactModalContent>
                    <ReactModalHeader modalTitle="You’re almost done"/>
                    <StyledText>
                        Please review our e-delivery agreement.
                    </StyledText>
                    <StyledText>
                        By saving your preferences, you agree that important documents that may provide
                        details about the plan and its features, including how to benefit from the plan,
                        as well as its fees and investment options, will be delivered to you electronically (“e-delivery”).
                        Please keep in mind the following regarding your preference for e-delivery:
                        <StyledList>
                            <ul>
                                <li>
                                    You have the right to withdraw your consent to e-delivery or request and
                                    receive paper versions of these documents at any time without charge.
                                </li>
                                <li>
                                    You can update any email address changes or modify your e-delivery preference
                                    settings on the Profile page at rps.troweprice.com, or by calling a T. Rowe Price
                                    retirement specialist.
                                </li>
                                <li>
                                    You must have a device that can access the internet, a current version of an
                                    internet web browser, and software that permits you to access and retain PDF files.
                                </li>
                            </ul>
                        </StyledList>
                    </StyledText>
                </ReactModalContent>
            </BeaconModal>

        </React.Fragment>
    )
}

